// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f1fb6cfc","404":"6eeebede"}[chunkId] + ".chunk.js";
};